// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010111/js/" + chunkId + "." + {"44":"336b915f","225":"1d50f5e8","481":"372a73a0","486":"57a55eea","770":"69173386"}[chunkId] + ".0.26775272607174605.chunk.js";
};